(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Clappr"));
	else if(typeof define === 'function' && define.amd)
		define(["Clappr"], factory);
	else if(typeof exports === 'object')
		exports["AirPlayPlugin"] = factory(require("Clappr"));
	else
		root["AirPlayPlugin"] = factory(root["Clappr"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _Clappr = __webpack_require__(1);

	var _icon = __webpack_require__(2);

	var _icon2 = _interopRequireDefault(_icon);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var AirPlayPlugin = function (_UICorePlugin) {
	  _inherits(AirPlayPlugin, _UICorePlugin);

	  _createClass(AirPlayPlugin, [{
	    key: 'name',
	    get: function get() {
	      return 'air_play';
	    }
	  }, {
	    key: 'airPlaySupported',
	    get: function get() {
	      return window.WebKitPlaybackTargetAvailabilityEvent && this._playback && this._playback.name === 'html5_video';
	    }
	  }, {
	    key: 'tagName',
	    get: function get() {
	      return 'button';
	    }
	  }, {
	    key: 'attributes',
	    get: function get() {
	      return {
	        class: 'media-control-button',
	        'data-airplay': ''
	      };
	    }
	  }, {
	    key: 'events',
	    get: function get() {
	      return {
	        click: this.clicked
	      };
	    }
	  }], [{
	    key: 'version',
	    get: function get() {
	      return ("0.0.1");
	    }
	  }]);

	  function AirPlayPlugin() {
	    _classCallCheck(this, AirPlayPlugin);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    var _this = _possibleConstructorReturn(this, _UICorePlugin.call.apply(_UICorePlugin, [this].concat(args)));

	    _this.render();
	    return _this;
	  }

	  AirPlayPlugin.prototype.bindEvents = function bindEvents() {
	    this.listenTo(this.core, _Clappr.Events.CORE_CONTAINERS_CREATED, this.containersCreated);
	    this.listenTo(this.core.mediaControl, _Clappr.Events.MEDIACONTROL_RENDERED, this.attachButton);
	  };

	  AirPlayPlugin.prototype.containersCreated = function containersCreated() {
	    var container = this.core.getCurrentContainer();
	    if (container != this._container) {
	      if (this._container) {
	        removeAvailabilityListener();
	      }
	      this._container = container;
	      this._playback = container.playback;
	      this.addAvailabilityListener();
	    }
	  };

	  AirPlayPlugin.prototype.removeAvailabilityListener = function removeAvailabilityListener() {
	    this._playback.el.removeEventListener('webkitplaybacktargetavailabilitychanged', this._availabilityListener);
	  };

	  AirPlayPlugin.prototype.addAvailabilityListener = function addAvailabilityListener() {
	    var _this2 = this;

	    if (!this._availabilityListener) {
	      this._availabilityListener = function (event) {
	        _Clappr.Log.debug(_this2.name, 'availability:', event.availability);
	        switch (event.availability) {
	          case "available":
	            _this2.$el.show();break;
	          case "not-available":
	            _this2.$el.hide();break;
	        }
	      };
	    }
	    this.$el.hide();
	    if (this.airPlaySupported) {
	      this._playback.el.addEventListener('webkitplaybacktargetavailabilitychanged', this._availabilityListener);
	      this._playback.el["x-webkit-airplay"] = "allow";
	    }
	  };

	  AirPlayPlugin.prototype.clicked = function clicked() {
	    if (this.airPlaySupported) {
	      this._playback.el.webkitShowPlaybackTargetPicker();
	    }
	  };

	  AirPlayPlugin.prototype.attachButton = function attachButton() {
	    var fullscreenButton = this.core.mediaControl.$fullscreenToggle;
	    if (fullscreenButton && fullscreenButton.length) {
	      this.$el.insertAfter(fullscreenButton);
	    } else {
	      this.core.mediaControl.$('media-control-right-panel').prepend(this.el);
	    }
	  };

	  AirPlayPlugin.prototype.render = function render() {
	    this.$el.empty();
	    this.$el.append(_icon2.default);
	    this.airPlaySupported || this.$el.hide();
	    this.attachButton();
	  };

	  return AirPlayPlugin;
	}(_Clappr.UICorePlugin);

	exports.default = AirPlayPlugin;
	module.exports = exports['default'];

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1\" viewBox=\"0 0 36.000000 28.000000\"><path d=\"M0 10v10h3.9c2.2 0 4.3-.5 4.6-1 .4-.6-.8-1-2.9-1H2V2h32v16h-3.6c-2.1 0-3.3.4-2.9 1 .3.5 2.4 1 4.6 1H36V0H0v10z\"></path><path d=\"M12 21.2l-5.3 6.3 5.7.3c3.1.2 8.2.2 11.3 0l5.6-.3-5.2-6c-2.9-3.3-5.6-6.1-6-6.3-.4-.1-3.1 2.6-6.1 6z\"></path></svg>"

/***/ })
/******/ ])
});
;